import { USER_FOUND } from 'redux-oidc';
import { UserContactViewModel } from '../../model/profile/types';
import { ApiError } from '../../api/types';

export const SAVING_USER_CONTACTINFO = 'SAVING_USER_CONTACTINFO';
export const SAVED_USER_CONTACTINFO = 'SAVED_USER_CONTACTINFO';
export const ERROR_SAVING_USER_CONTACTINFO = 'ERROR_SAVING_USER_CONTACTINFO';

export const UPDATING_DEVICE_TRUST_PARTICIPATION_STATUS =
  'UPDATING_DEVICE_TRUST_PARTICIPATION_STATUS';
export const UPDATED_DEVICE_TRUST_PARTICIPATION_STATUS =
  'UPDATED_DEVICE_TRUST_PARTICIPATION_STATUS';
export const ERROR_UPDATING_DEVICE_TRUST_PARTICIPATION_STATUS =
  'ERROR_UPDATING_DEVICE_TRUST_PARTICIPATION_STATUS';

export interface UserLoaded {
  type: typeof USER_FOUND;
  payload: StsUser;
}

export interface SavedUserContactInfo {
  type: typeof SAVED_USER_CONTACTINFO;
  payload: UserContactViewModel;
}

export interface SavingUserContactInfo {
  type: typeof SAVING_USER_CONTACTINFO;
  payload: undefined;
}

export interface ErrorSavingUserContactInfo {
  type: typeof ERROR_SAVING_USER_CONTACTINFO;
  payload: ApiError;
}

export interface UpdatingDeviceTrustStatus {
  type: typeof UPDATING_DEVICE_TRUST_PARTICIPATION_STATUS;
  payload: undefined;
}

export interface UpdatedDeviceTrustStatus {
  type: typeof UPDATED_DEVICE_TRUST_PARTICIPATION_STATUS;
  payload: boolean;
}

export interface ErrorUpdatingDeviceTrustPreferences {
  type: typeof ERROR_UPDATING_DEVICE_TRUST_PARTICIPATION_STATUS;
  payload: ApiError;
}
export type UserProfileActionTypes =
  | UserLoaded
  | SavingUserContactInfo
  | SavedUserContactInfo
  | ErrorSavingUserContactInfo
  | UpdatingDeviceTrustStatus
  | UpdatedDeviceTrustStatus
  | ErrorUpdatingDeviceTrustPreferences;

export interface StsAddress {
  street_address?: string;
  locality?: string;
  region?: string;
  country?: string;
  postal_code?: string;
}

export interface StsProfile {
  given_name?: string;
  family_name?: string;
  title?: string;
  phone_number?: string;
  email?: string;
  middle_name?: string;
  address?: string;
  institution?: string;
  department?: string;
  devicetrustenabled?: string;
  devicetrustcantoggle?: string;
}

export interface StsUser {
  profile: StsProfile;
}
